import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';

class TopMenu extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
$('title').text(this.props.title);
}

 show_div(id){
    setTimeout(function () {$('html, body').animate({
        scrollTop: $(id).offset().top - 95
    }, 10);}, 100);
 }
  render() {
    return (


        <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
            <Link to="/" className="navbar-brand d-flex align-items-center text-center py-0 px-4 px-lg-4">
                <img className="img-fluid flex-shrink-0 home-menu-logo" src="/assets/img/logo1.png"/>
            </Link>
            <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <i class="fa fa-bars"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-auto p-4 p-lg-0">
                {/*<Link to="/freeConsultation"className="nav-item nav-link btn btn-primary rounded-0 py-4 px-lg-5 d-lg-block loging_color free_con_but" id="menu_free_consultation">Free Consultation</Link>*/}
                    <Link to="/" id="/" className="nav-item nav-link active">Home</Link>
                    <div className="nav-item dropdown">
                    <spam id="/aboutus" className="nav-link dropdown-toggle">About Us</spam>
                        <div className="dropdown-menu rounded-0 m-0">
                            <Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#aboutus')}>About Bylaws</Link>
                            <Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#story')}>Our Story</Link>
                            <Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#what_we_do')}>What We Do</Link>
                            <Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#mission')}>Mission & Vision</Link>
                            <Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#awards_rankings')}>Awards and Rankings</Link>
                            {/*<Link to="/aboutus" className="dropdown-item" onClick={() => this.show_div('#careers')}>Careers</Link>*/}
                        </div>
                    </div>
                    <div className="nav-item dropdown">
                        <spam id="/practice" className="nav-link dropdown-toggle">Practice Areas</spam>
                        <div className="dropdown-menu rounded-0 m-0">
                            <Link to="/practice" className="dropdown-item" onClick={() => this.show_div('#non_litigation')}>Non-litigation</Link>
                            <Link to="/practice" className="dropdown-item" onClick={() => this.show_div('#litigation')}>Litigation</Link>
                            {/*<Link to="/practice" className="dropdown-item" onClick={() => this.show_div('#aboutus')}>Pro-bono</Link>*/}
                        </div>
                    </div>

                    <div className="nav-item dropdown">
                        <spam id="/services" className="nav-link dropdown-toggle">Service Industry</spam>
                        <div className="dropdown-menu rounded-0 m-0">
                            <Link to="/services" className="dropdown-item" onClick={() => this.show_div('#corporate_capital_markets')}>Corporate / Capital Market</Link>
                            <Link to="/services" className="dropdown-item" onClick={() => this.show_div('#banking_no_banking')}>Banking / Non-Banking</Link>
                            <Link to="/services" className="dropdown-item" onClick={() => this.show_div('#other_area')}>Others</Link>
                        </div>
                    </div>

                    <div className="nav-item dropdown">
                        <Link to="/ourteam" id="/ourteam" className="nav-item nav-link">Team</Link>
                    </div>

                    <div className="nav-item dropdown">
                        <spam id="/collaborations" className="nav-link dropdown-toggle">Collaborations</spam>
                        <div className="dropdown-menu rounded-0 m-0">
                          <Link to="/collaborations"className="dropdown-item" onClick={() => this.show_div('#consultants')}>Consultants</Link>
                          {/*<Link to="/collaborations"className="dropdown-item">Advisors</Link>
                          <Link to="/collaborations"className="dropdown-item">Technical Support</Link>*/}
                        </div>
                    </div>



                    <div className="nav-item dropdown">
                        <spam id="/new_updates" className="nav-link dropdown-toggle" >News and Updates </spam>
                        <div className="dropdown-menu rounded-0 m-0">
                          <Link to="/new_updates"className="dropdown-item">Regulatory Updates</Link>
                          {/*<Link to="/new_updates"className="dropdown-item">Legal Updates</Link>
                          <Link to="/new_updates"className="dropdown-item">Other updates</Link>*/}
                        </div>
                    </div>

                    <div className="nav-item dropdown">
                        <spam id="/pro_bono_begal_help" className="nav-link dropdown-toggle">Insights</spam>
                        <div className="dropdown-menu rounded-0 m-0">
                          <Link to="/pro_bono_begal_help"className="dropdown-item">Pro-Bono Legal Help</Link>
                          {/*<Link to="/videos"className="dropdown-item">Videos</Link>
                          <Link to="/articles"className="dropdown-item">Articles</Link>
                          <Link to="/blogs"className="dropdown-item">Blogs</Link>*/}
                        </div>
                    </div>

                    <Link to="/contact" id="/contact"className="nav-item nav-link">Contact Us</Link>
                    <div className="nav-item dropdown">
                        <spam to="#login" className="nav-link dropdown-toggle">Sign Up/Log in</spam>
                        <div className="dropdown-menu rounded-0 m-0 last_menu_dropdown">
                          <Link to="/freeConsultation"className="dropdown-item">Free Consultation</Link>
                          {/*<Link to="/scheduleConsultation"className="dropdown-item">Schedule Consultation</Link>*/}
                          <Link to="/login"className="dropdown-item">Login</Link>
                        </div>
                    </div>
                </div>
             </div>
        </nav>

    );
  }
}

export default TopMenu;
